import ApiService from "../../../ceres/services/ApiService";

const state = () => ({
	isLoading: true,
	isRequested: false,
	data: {}
});

const mutations = {
	setIsLoading(state, event) {
		state.isLoading = event;
	},
	setIsRequested(state) {
		state.isRequested = true;
	},
	setData(state, data) {
		state.data = data;
	}
};

const actions = {
	getExchangeRatios({ state, commit }) {
		if (!state.isRequested) {
			commit("setIsRequested");
			ApiService.get("/rest/exchangeRatios")
				.done(response => {
					commit("setData", response);
				})
				.always(() => {
					commit("setIsLoading", false);
				});
		}
	}
};

const getters = {
	getExchangeRatios: state => {
		return state.data;
	}
};

export default {
	actions,
	state,
	mutations,
	getters
};
